import { Locale } from '~/stores/app/types';

export const DEFAULT_PAGE_LIMIT = 9;

export const DEFAULT_QUICK_SEARCH_PAGE_LIMIT = 5;

export const DEFAULT_LOCALE = Locale['en-US'];

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_CURRENCY = Currency.USD;

export const HOME_PAGE_SLUG = 'home';
